import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import auction from './modules/auction';
import item from './modules/item';
import categoryList from './modules/category-list';
import person from './modules/person';
import bidList from './modules/bid-list';
import pendingBidList from './modules/pending-bid-list';
import pendingBidForm from './modules/pending-bid-form';
import bidForm from './modules/bid-form';
import flashMessages from './modules/flash-messages';
import breadcrumb from './modules/breadcrumb';
import tags from './modules/tags';
import planning from './modules/planning';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
	modules: {
		auth,
		auction,
		item,
		categoryList,
		person,
		pendingBidList,
		pendingBidForm,
		bidList,
		bidForm,
		flashMessages,
		breadcrumb,
		tags,
		planning
	},
	strict: debug
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js